class Menu {
  constructor(menu) {
    this.menu = menu;
    this.trigger = this.menu.querySelector(".m-navigation__trigger");
    this.initMenu();
  }

  initMenu() {
    this.trigger.addEventListener('click', this.toggle);
  }

  toggle(e) {
    e.target.parentElement.classList.toggle('m-navigation__inner--open');
  }
}

export default Menu
